import React from 'react'
import CustomerManagementFeatureBox1 from './CustomerManagement-feature-box1'
function CustomerManagementfeature() {
    return (
        <>
            <CustomerManagementFeatureBox1 />
        </>
    )
}

export default CustomerManagementfeature